import { PlankPatternForm } from "./PlankPattern.form";

export const ChevronPatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="chevron"
    width={{ value: "12", min: 5, max: 50 }}
    height={{ value: "60", min: 5, max: 100 }}
  />
);
